import { useEffect, useState, useMemo } from "react";
import api from "../../services/api";

function formatHours(value) {
  const rounded = Math.round((value || 0) * 100) / 100;
  return Number.isInteger(rounded) ? String(rounded) : String(rounded);
}

function calcPercent(previsto, realizado) {
  if (!previsto) return 0;
  return Math.round((realizado / previsto) * 100);
}

function UserIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" stroke="#4b5563" strokeWidth="1.6" />
      <path
        d="M4 20c0-3.6 3.6-6 8-6s8 2.4 8 6"
        stroke="#4b5563"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

function FolderIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 6.5C3 5.67 3.67 5 4.5 5h4.4c.5 0 .96.24 1.25.65L11 7h8.5c.83 0 1.5.67 1.5 1.5v9c0 .83-.67 1.5-1.5 1.5h-15C3.67 19 3 18.33 3 17.5v-11Z"
        stroke="#6b7280"
        strokeWidth="1.5"
      />
    </svg>
  );
}

function Chevron({ open }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      style={{
        transform: open ? "rotate(0deg)" : "rotate(-90deg)",
        transition: "transform 0.15s ease",
        flexShrink: 0,
      }}
    >
      <path
        d="M6 9l6 6 6-6"
        stroke="#6b7280"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

// Tabela "Tipo | dia dia dia ... | Total" reutilizada para o total do
// executante e para cada projeto individual.
function DailyTable({ days, previstoPorDia, realizadoPorDia, totalPrevisto, totalRealizado }) {
  return (
    <div style={{ overflowX: "auto" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 420 }}>
        <thead>
          <tr style={{ background: "#f3f4f6" }}>
            <th
              style={{
                textAlign: "left",
                padding: "8px 12px",
                fontSize: "12px",
                color: "#6b7280",
                fontWeight: 600,
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              Tipo
            </th>
            {days.map((day) => (
              <th
                key={day.date}
                style={{
                  textAlign: "center",
                  padding: "8px 12px",
                  borderBottom: "1px solid #e5e7eb",
                  minWidth: 64,
                }}
              >
                <div style={{ fontSize: "13px", fontWeight: 600, color: "#374151" }}>
                  {day.day}
                </div>
                <div style={{ fontSize: "10px", color: "#9ca3af", letterSpacing: "0.03em" }}>
                  {day.weekday.toUpperCase()}
                </div>
              </th>
            ))}
            <th
              style={{
                textAlign: "center",
                padding: "8px 12px",
                fontSize: "12px",
                color: "#6b7280",
                fontWeight: 600,
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          <tr style={{ background: "#ffffff" }}>
            <td style={{ padding: "10px 12px", color: "#374151", borderBottom: "1px solid #f1f5f9" }}>
              Previsto
            </td>
            {days.map((day) => (
              <td
                key={day.date}
                style={{ textAlign: "center", padding: "10px 12px", color: "#111827", borderBottom: "1px solid #f1f5f9" }}
              >
                {formatHours(previstoPorDia[day.date] || 0)}
              </td>
            ))}
            <td
              style={{
                textAlign: "center",
                padding: "10px 12px",
                fontWeight: 700,
                color: "#111827",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              {formatHours(totalPrevisto)}
            </td>
          </tr>
          <tr style={{ background: "#f9fafb" }}>
            <td style={{ padding: "10px 12px", color: "#374151" }}>Realizado</td>
            {days.map((day) => (
              <td key={day.date} style={{ textAlign: "center", padding: "10px 12px", color: "#111827" }}>
                {formatHours(realizadoPorDia[day.date] || 0)}
              </td>
            ))}
            <td style={{ textAlign: "center", padding: "10px 12px", fontWeight: 700, color: "#111827" }}>
              {formatHours(totalRealizado)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

function WeeklyTable({ weeks, horasPorSemana, total }) {
  if (!weeks.length) {
    return (
      <div style={{
        color: "#9ca3af",
        fontSize: "13px",
        padding: "8px 0",
      }}>
        Nenhuma hora trabalhada registrada.
      </div>
    );
  }
  const cell = {
    textAlign: "center",
    padding: "10px 12px",
    color: "#111827",
  };

  return (
    <div style={{ overflowX: "auto"}}>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          minWidth: 420,
        }}
      >
        <thead>
          <tr style={{ background: "#f3f4f6" }}>
            <th
              style={{
                textAlign: "left",
                padding: "8px 12px",
                fontSize: "12px",
                color: "6b7280",
                fontWeight: 600,
                borderBottom: "1px solid #e5e7eb"
              }}
            >
              Tipo
            </th>
            {weeks.map((week) => (
              <th
                key={week.weekStart}
                style={{
                  textAlign: "center",
                  padding: "8px 12px",
                  borderBottom: "1px solid #e5e7eb",
                  minWidth: 96,
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "#374151",
                  }}
                >
                  {week.label}
                </div>
                <div
                  style={{
                    fontSize: "10px",
                    color: "#9ca3af",
                    letterSpacing: "0.03em",
                  }}
                >
                  SEMANA
                </div>
              </th>
            ))}
            <th
              style={{
                textAlign: "center",
                padding: "8px 12px",
                color: "#6b7280",
                fontWeight: "600",
                borderBottom: "1px solid #e5e7eb"
              }}
            >
              Total
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              style={{
                padding: "10px 12px",
                color: "#374151",
              }}
            >
              Trabalhadas
            </td>
            {weeks.map((week) => (
              <td key={week.weekStart} style={cell}>
                {formatHours(horasPorSemana[week.weekStart] || 0)}
              </td>
            ))}
            <td style={{ ...cell, fontWeight: 700 }}>{formatHours(total)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default function DailyAssignment() {
  const [projects, setProjects] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");
  const [executantes, setExecutantes] = useState([]);
  const [dayColumns, setDayColumns] = useState([]);
  const [collapsedExecutantes, setCollapsedExecutantes] = useState({});
  const [collapsedProjetos, setCollapsedProjetos] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [pagination, setPagination] = useState({ page: 1, limit: itemsPerPage, total: 0, totalPages: 1 });
  const [weekColumns, setWeekColumns] = useState([]);

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedProject]);

  useEffect(() => {
    const carregarProjetos = async () => {
      setLoadingProjects(true);
      try {
        const response = await api.get("/api/planejamentoProjetos");
        setProjects(response.data || []);
      } catch (error) {
        console.error("Erro ao buscar projetos:", error);
      } finally {
        setLoadingProjects(false);
      }
    };

    carregarProjetos();
  }, []);

  const projectId = useMemo(() => {
    if (!selectedProject) return "";
    const project = projects.find((item) => item.nome === selectedProject);
    return project ? project.id : "";
  }, [selectedProject, projects]);

  useEffect(() => {
    const buscarAlocamentoDiario = async () => {
      setLoading(true);
      try {
        const response = await api.get("/dailyAssignment", {
          params: {
            ...(selectedProject && { projectId }),
            page: currentPage,
            limit: itemsPerPage,
          },
        });

        setExecutantes(response.data.executantes || []);
        setDayColumns(response.data.dayColumns || []);
        setWeekColumns(response.data.weekColumns || []);
        setPagination(response.data.pagination || { page: 1, limit: itemsPerPage, total: 0, totalPages: 1 });
      } catch (error) {
        console.error("Erro ao buscar alocação diária:", error);
        setExecutantes([]);
        setDayColumns([]);
        setWeekColumns([]);
      } finally {
        setLoading(false);
      }
    };

    buscarAlocamentoDiario();
  }, [selectedProject, projectId, currentPage]);

  const toggleExecutante = (id) => {
    setCollapsedExecutantes((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const toggleProjeto = (key) => {
    setCollapsedProjetos((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div style={{ background: "#f3f4f6", minHeight: "100vh", padding: "32px 0 60px" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}>
        <div
          style={{
            fontSize: "12px",
            color: "#6b7280",
            marginBottom: "18px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <span>Home</span>
          <span>›</span>
          <span>Gestão</span>
          <span>›</span>
          <strong style={{ color: "#374151" }}>Alocação diária</strong>
        </div>

        <h1 style={{ fontSize: "44px", margin: 0, fontWeight: 700, color: "#1f2937" }}>
          Alocação diária
        </h1>
        <p style={{ margin: "8px 0 20px", color: "#4b5563", fontSize: "18px" }}>
          Horas previstas e realizadas por executante e projeto
        </p>

        <div
          style={{
            borderTop: "1px dashed #d1d5db",
            marginBottom: "24px",
            paddingTop: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              flexWrap: "wrap",
            }}
          >
            <div style={{ flex: 1, minWidth: 240 }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: 600,
                  color: "#374151",
                }}
              >
                Selecionar projeto:
              </label>

              <select
                value={selectedProject}
                onChange={(event) => setSelectedProject(event.target.value)}
                disabled={loadingProjects}
                style={{
                  width: "100%",
                  maxWidth: "500px",
                  height: "42px",
                  padding: "8px 12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  background: "#fff",
                  fontSize: "16px",
                  color: "#111827",
                }}
              >
                <option value="">{loadingProjects ? "Carregando..." : "Todos os projetos"}</option>
                {projects.map((projeto) => (
                  <option key={projeto.id} value={projeto.nome}>
                    {projeto.nome}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {!selectedProject && (
            <div style={{ marginTop: "10px", color: "#6b7280", fontSize: "14px" }}>
              Selecione o projeto para ter acesso à alocação diária de horas por executante.
            </div>
          )}
        </div>

        {loading ? (
          <div
            style={{
              background: "#fff",
              border: "1px solid #dfe3e8",
              borderRadius: "10px",
              padding: "18px 14px",
              color: "#6b7280",
            }}
          >
            Carregando...
          </div>
        ) : executantes.length === 0 ? (
          <div
            style={{
              background: "#fff",
              border: "1px solid #dfe3e8",
              borderRadius: "10px",
              padding: "18px 14px",
              color: "#6b7280",
              textAlign: "center",
            }}
          >
            Nenhum dado encontrado.
          </div>
        ) : (
          executantes.map((executante) => {
            const isCollapsed = !!collapsedExecutantes[executante.id];
            const qtdProjetos = executante.projetos.length;

            return (
              <div
                key={executante.id}
                style={{
                  background: "#fff",
                  border: "1px solid #dfe3e8",
                  borderRadius: "10px",
                  overflow: "hidden",
                  marginBottom: "18px",
                }}
              >
                <div
                  onClick={() => toggleExecutante(executante.id)}
                  style={{
                    background: "#dbeafe",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Chevron open={!isCollapsed} />
                    <UserIcon />
                    <span style={{ fontWeight: 600, color: "#1f2937" }}>
                      {executante.nome} ({qtdProjetos} {qtdProjetos === 1 ? "projeto" : "projetos"})
                    </span>
                  </div>

                  <div style={{ textAlign: "right" }}>
                    <div
                      style={{
                        display: "flex",
                        gap: "24px",
                        fontSize: "10px",
                        color: "#6b7280",
                        letterSpacing: "0.03em",
                        marginBottom: "2px",
                      }}
                    >
                      <span style={{ width: 50 }}>PREVISTO</span>
                      <span style={{ width: 50 }}>REALIZADO</span>
                      <span style={{ width: 40 }}>EXEC.</span>
                    </div>
                    <div style={{ display: "flex", gap: "24px", fontWeight: 700, color: "#111827" }}>
                      <span style={{ width: 50 }}>{formatHours(executante.totalPrevisto)}h</span>
                      <span style={{ width: 50 }}>{formatHours(executante.totalRealizado)}h</span>
                      <span style={{ width: 40 }}>{executante.percentual}%</span>
                    </div>
                  </div>
                </div>

                {!isCollapsed && (
                  <>
                    <div style={{ padding: "16px" }}>
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: "12px",
                          color: "#6b7280",
                          letterSpacing: "0.03em",
                          marginBottom: "8px",
                        }}
                      >
                        TOTAL DIÁRIO DO EXECUTANTE
                      </div>
                      <DailyTable
                        days={dayColumns}
                        previstoPorDia={executante.porDia.previsto}
                        realizadoPorDia={executante.porDia.realizado}
                        totalPrevisto={executante.totalPrevisto}
                        totalRealizado={executante.totalRealizado}
                      />
                      <div
                        style={{
                          fontWeight: 700,
                          fontSize: "12px",
                          color: "#6b7280",
                          letterSpacing: "0.03em",
                          margin: "20px 0 8px",
                        }}
                      >
                        HORAS TRABALHADAS POR SEMANA
                      </div>
                      <WeeklyTable
                        weeks={weekColumns}
                        horasPorSemana={executante.porSemana || {}}
                        total={executante.totalSemanal || 0}
                      />
                    </div>

                    {executante.projetos.map((projeto) => {
                      const projetoKey = `${executante.id}-${projeto.id}`;
                      const projetoCollapsed = !!collapsedProjetos[projetoKey];
                      const projetoPercentual = calcPercent(projeto.totalPrevisto, projeto.totalRealizado);

                      return (
                        <div key={projetoKey} style={{ borderTop: "1px solid #e5e7eb" }}>
                          <div
                            onClick={() => toggleProjeto(projetoKey)}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "10px 16px",
                              cursor: "pointer",
                              background: "#f9fafb",
                            }}
                          >
                            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                              <Chevron open={!projetoCollapsed} />
                              <FolderIcon />
                              <span style={{ fontWeight: 600, color: "#374151", fontSize: "14px" }}>
                                {projeto.nome}
                              </span>
                            </div>
                            <div style={{ fontSize: "13px", color: "#6b7280" }}>
                              Prev: <strong style={{ color: "#111827" }}>{formatHours(projeto.totalPrevisto)}</strong>{" "}
                              &nbsp;Real:{" "}
                              <strong style={{ color: "#111827" }}>{formatHours(projeto.totalRealizado)}</strong>{" "}
                              &nbsp;
                              <strong style={{ color: "#111827" }}>{projetoPercentual}%</strong>
                            </div>
                          </div>

                          {!projetoCollapsed && (
                            <div style={{ padding: "0 16px 16px" }}>
                              <DailyTable
                                days={dayColumns}
                                previstoPorDia={projeto.porDia.previsto}
                                realizadoPorDia={projeto.porDia.realizado}
                                totalPrevisto={projeto.totalPrevisto}
                                totalRealizado={projeto.totalRealizado}
                              />
                              <div style={{ height: 12 }} />
                              <WeeklyTable
                                weeks={weekColumns}
                                horasPorSemana={projeto.porSemana || {}}
                                total={projeto.totalSemanal || 0}
                              />
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </>
                )}
              </div>
            );
          })
        )}
      </div>
      {pagination.totalPages > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            marginTop: "24px",
          }}
        >
          <button
            onClick={() => setCurrentPage((page) => page - 1)}
            disabled={currentPage === 1 || loading}
            style={{
              padding: "8px 14px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              background: "#fff",
              cursor: currentPage === 1 ? "not-allowed" : "pointer",
              opacity: currentPage === 1 ? 0.5 : 1,
            }}
          >
            Anterior
          </button>

          <span
            style={{
              padding: "8px 14px",
              color: "#374151",
              fontSize: "14px",
            }}
          >
            Página {pagination.page} de {pagination.totalPages}
          </span>

          <button
            onClick={() => setCurrentPage((page) => page + 1)}
            disabled={currentPage === pagination.totalPages || loading}
            style={{
              padding: "8px 14px",
              border: "1px solid #d1d5db",
              borderRadius: "6px",
              background: "#fff",
              cursor: currentPage === pagination.totalPages ? "not-allowed" : "pointer",
              opacity: currentPage === pagination.totalPages ? 0.5 : 1,
            }}
          >
            Próxima
          </button>
        </div>
      )}
    </div>
  );
}
